import { MapPin, CalendarDays, ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";

export default function Events({ events, whatsapp }) {
  if (!events.length) return null;

  const waLink = (title) =>
    `https://wa.me/${whatsapp}?text=${encodeURIComponent(
      `Hola MO by Vir 🌸 Quiero reservar mi lugar para el evento: ${title}`
    )}`;

  return (
    <section
      id="eventos"
      data-testid="events-section"
      className="bg-surface py-24 md:py-32"
    >
      <div className="max-w-[1400px] mx-auto px-5 md:px-10">
        <Reveal className="max-w-2xl">
          <span className="text-[11px] uppercase tracking-[0.3em] text-rose">
            Agenda MO by Vir
          </span>
          <h2 className="mt-4 font-serif font-light text-4xl md:text-6xl leading-none">
            Eventos & <span className="italic text-rose">catas</span>
          </h2>
          <p className="text-taupe mt-5 font-light">
            Experiencias íntimas para descubrir fragancias en miniatura. Cupos limitados.
          </p>
        </Reveal>

        <div className="mt-14 space-y-px bg-line border border-line">
          {events.map((e, i) => (
            <Reveal key={e.id} delay={i * 0.08}>
              <a
                data-testid={`event-card-${e.id}`}
                href={waLink(e.title)}
                target="_blank"
                rel="noreferrer"
                className="group bg-cream flex flex-col md:flex-row md:items-center gap-6 p-6 md:p-8 hover:bg-espresso transition-colors duration-500"
              >
                <div className="w-full md:w-56 h-44 overflow-hidden shrink-0">
                  <img
                    src={e.image}
                    alt={e.title}
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                </div>
                <div className="flex-1">
                  <h3 className="font-serif text-2xl md:text-3xl text-espresso group-hover:text-cream transition-colors">
                    {e.title}
                  </h3>
                  <p className="text-taupe text-sm font-light mt-2 max-w-xl group-hover:text-cream/70 transition-colors">
                    {e.description}
                  </p>
                  <div className="flex flex-wrap gap-x-6 gap-y-2 mt-4 text-[11px] uppercase tracking-[0.15em] text-taupe group-hover:text-cream/60 transition-colors">
                    {e.date && (
                      <span className="flex items-center gap-1.5">
                        <CalendarDays size={13} /> {e.date}
                      </span>
                    )}
                    {e.location && (
                      <span className="flex items-center gap-1.5">
                        <MapPin size={13} /> {e.location}
                      </span>
                    )}
                  </div>
                </div>
                <span className="shrink-0 w-12 h-12 rounded-full border border-espresso/30 flex items-center justify-center text-espresso group-hover:bg-cream group-hover:border-cream transition-colors">
                  <ArrowUpRight size={18} />
                </span>
              </a>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
